module.exports = __webpack_public_path__ + "media/images/connected-ec0c3787.svg";